import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import axios from 'axios';

import { handleRequest, handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { ENDPOINT, DEFAULT_HEADERS } from 'api/configuration.js';

class QrRoutes extends PureComponent {
  constructor(props) {
    super();
    this.state = { ...props, url: '' };
  }
  componentDidMount() {
    const { qrcode } = this.state.match.params;

    const ajax = axios.create({ baseURL: ENDPOINT, timeout: 30000 });

    ajax.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    const url = '/qrredirec/' + qrcode;
    return ajax
      .get(url)
      .then((response) => {
        this.setState({ url: response.data.qrcode.url_origin });
        return response;
      })
      .then(handleApiSucess)
      .catch((error) => {
        this.setState({ url: '/' });
        handleApiError(error);
      });
  }

  render() {
    if (this.state.url) {
      window.location.href = this.state.url;
    }
    return <section></section>;
  }
}

export default translate()(QrRoutes);



// WEBPACK FOOTER //
// src/modules/auth/routes/QrRoutes.js